import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';
const FaqOne = (props) => {
  const { itemClass, items } = props;

  return (
    <div
      className={
        itemClass
          ? itemClass
          : 'it-custom-accordion it-custom-accordion-style-2'
      }
    >
      <Accordion className="accordion" preExpanded={['a']} allowZeroExpanded>
        {items.map((item) => (
          <AccordionItem
            key={item.id}
            className="accordion-items"
            uuid={item.id}
          >
            <AccordionItemHeading className="accordion-header">
              <AccordionItemButton className="accordion-buttons text-white" style={{backgroundColor:"#0e2a46"}}>
                {item.btnText}
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <div className="accordion-body">
              <div className="it-about-4-list-wrap d-flex align-items-start">
                      <div className="it-about-5-list">
                          <ul style={{backgroundColor: "transparent"}}>
                            {item.description.map((point, index) => (
                            <li className='pr-0 pb-10 text-black' key={index} ><i className="fa-regular fa-user-tie"></i>{point}</li>
                            ))}
                          </ul>
                        </div>
                </div>
        
              

              </div>
            </AccordionItemPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};
export default FaqOne;
